import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login/Index.vue"),
  },
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home/Index.vue"),
    children: [
      {
        path: "/",
        name: "Main",
        component: () => import("../views/Home/Main.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
